export type PendingWalletAction = { key: string; payload: Record<string, string | number | undefined> };
export const walletActionStorageKey = (actorId: number | undefined, siteId: number | undefined, kind: string) => `notification-wallet:${actorId}:${siteId}:${kind}`;
export function readWalletAction(key: string): PendingWalletAction | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) || "null");
    return value && typeof value.key === "string" && value.payload && typeof value.payload === "object" ? value : null;
  } catch { return null; }
}
export function saveWalletAction(key: string, action: PendingWalletAction) {
  // Persist before sending; without storage a reload could cause duplicate credit.
  sessionStorage.setItem(key, JSON.stringify(action));
}
export function clearWalletAction(key: string) { sessionStorage.removeItem(key); }
export function isDefinitiveWalletFailure(error: any) {
  const status = error?.response?.status;
  return [400, 401, 403, 404, 409, 422].includes(status);
}
